import { Form, Input, Modal } from 'antd';
import styled from 'styled-components';

const StyledDiv = styled.div``;

interface VendorMaterialAddModalProps {
  visible: boolean;
  data: any[];
  onCreate: (value: any) => void;
  onCancel: () => void;
}

function VendorMaterialAddModal({
  visible,
  data,
  onCreate,
  onCancel,
}: VendorMaterialAddModalProps) {
  const [form] = Form.useForm();

  const checkDuplicateName = (name: string) => {
    if (data.filter((value: any) => value.name === name).length === 0) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('중복된 이름이 존재합니다.'));
  };

  return (
    <StyledDiv>
      <Modal
        open={visible}
        title="사업자 자재 분류 추가"
        okText="확인"
        cancelText="취소"
        onCancel={onCancel}
        onOk={() => {
          form
            .validateFields()
            .then((values) => {
              onCreate(values);
            })
            .catch((info) => {
              console.error('Validate Failed:', info);
            });
        }}
      >
        <Form form={form} layout="vertical" initialValues={{}}>
          <Form.Item
            name="name"
            label="사업자 자재 분류 이름"
            rules={[
              {
                required: true,
              },
              {
                validator: (_, value) => checkDuplicateName(value),
              },
            ]}
          >
            <Input type="name" />
          </Form.Item>
        </Form>
      </Modal>
    </StyledDiv>
  );
}

export default VendorMaterialAddModal;
